/**
 * Typesense `include_fields` for SRP job search — matches Algolia listing/map hit payloads.
 * Omits large text fields not rendered on hit cards (description, employerOverview, requirements, responsibilities).
 */
export const TYPESENSE_SRP_INCLUDE_FIELDS = [
  'id',
  'objectID',
  'url',
  'score',
  'lastSeen',
  'postedDate',
  'applicationDeadline',
  'isActive',
  'title',
  'normalisedTitle',
  'normalisedRoleLevel',
  'field',
  'specialisations',
  'educationLevel',
  'minimumYearsOfExperience',
  'peopleManagementTier',
  'companyId',
  'companyName',
  'companyIndustry',
  'companyURL',
  'logoUrl',
  'brandColour',
  'heroImage',
  'location',
  'locationList',
  'geoloc',
  'remoteness',
  'isFinland',
  'jobType',
  'benefits',
  'skillsAndTechnologies',
  'requiredLanguages',
  'optionalLanguages',
  'salaryRangeMin',
  'salaryRangeMax',
  'salaryPeriod',
  'salaryDetails',
  'currency',
  'salaryIsEstimate',
  'isOpenApplication',
  'isSummerJob',
  'isDriversLicenseRequired',
  'isTyomarkkinatori',
  'vacationWeeks',
  'locale',
].join(',');
